import React from 'react';

import { Typography } from '@mui/material';

import ReadOnlyTextEditor from '@ivy/components/molecules/ReadOnlyTextEditor';
import SectionHeader, {
	type SectionHeaderProps,
} from '@ivy/components/molecules/SectionHeader';
import { gql, type FragmentType, getFragmentData } from '@ivy/gql/types';
import { isNonEmptyHtml } from '@ivy/lib/validation/html';

const OrgAbout_OrgFDoc = gql(/* GraphQL */ `
	fragment OrgAbout_Org on organization {
		id
		description
		ownershipStructure: ownership_structure
		contractsAgg: contracts_aggregate(where: { active: { _eq: true } }) {
			aggregate {
				count
			}
		}
	}
`);

export interface OrgAboutProps
	extends Omit<SectionHeaderProps, 'title' | 'noBackground'> {
	org: FragmentType<typeof OrgAbout_OrgFDoc>;
}

const OrgAbout = ({ org: rawOrg, ...props }: OrgAboutProps) => {
	const org = getFragmentData(OrgAbout_OrgFDoc, rawOrg);

	return (
		<SectionHeader title='About' noBackground {...props}>
			{isNonEmptyHtml(org.description) ? (
				<ReadOnlyTextEditor
					content={org.description}
					startingHeaderLevel={3}
					startingHeaderLevelStyles={5}
					sx={{ color: 'text.icon' }}
				/>
			) : (
				<Typography
					variant='body1'
					fontStyle='italic'
					sx={{
						color: 'text.icon',
						whiteSpace: 'pre-wrap',
					}}
				>
					There is nothing here yet.
				</Typography>
			)}
		</SectionHeader>
	);
};

export default OrgAbout;
